import { render } from "./beds_tab.vue?vue&type=template&id=56c71c76"
import script from "./beds_tab.vue?vue&type=script&lang=js"
export * from "./beds_tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__